import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { ServiceCRUD } from '../../../../shared/crud/ServiceCRUD';


@Injectable()
export class RmpvOficinaMensalService extends ServiceCRUD {
  private baseUrlService: string;
  url: string;
  nome: string;
  
  
  constructor(http: HttpClient, router: Router) {  
    super(http, router)
    this.baseUrlService = environment.URL_API

  }

  setNomeServico(nome: any){
    this.nome = nome;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/rmpv/${this.nome}/mensal`; 
  }

}
